<template>
    <div class="clearfix main_center"  v-loading.fullscreen.lock="loading">
        <div class="top-content">
            <div class="left-navbar">
                <el-button @click="back('project_extract_list')" size="small">返回</el-button>
                <el-button type="primary" @click="back('resultNotice_detail',{id:form.id ,flag:1})" plain size="small">发布检查结果公告</el-button>
            </div>
        </div>
        <div class="right-content clearfix">
            <el-form  label-width="180px" class="form viewFormWrapper">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>抽取基本信息</span>
                    </div>
                    <el-row :gutter="15">
                        <el-col :span="24">
                            <el-form-item label="任务名称：" >
                                <span >{{ form.workName || "-" }} </span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15">
                        <el-col :span="12">
                            <el-form-item label="抽取编号：" >
                                <span >{{ form.extractCode  || "-" }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="抽取类型：" >
                                <span >{{ form.extractTypeName  || "-" }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15">
                        <el-col :span="24">
                            <el-form-item label="监督检查单位：">
                                <span >{{ form.supervisionIdsName  || "-" }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="15">
                        <el-col :span="12">
                            <el-form-item label="抽取完成时间：" >
                                <span >{{ form.extractTime  || "-" }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="抽取人员：">
                                <span >{{ form.extractorName || '-'}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>项目随机抽取规则</span>
                    </div>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="项目所属监管单位：" prop='superviseDeptCode' style="width:100%;">
                                <span>{{form.superviseDeptCodeName}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="项目名称包含：" prop='projectName' style="width:100%;">
                                <span>{{form.projectName}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="项目招标人名称包含：" prop='tendererName' style="width:100%;">
                                <span>{{form.tendererName || "-"}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="项目招标代理名称包含：" prop='tenderAgencyName' style="width:100%;">
                                <span>{{form.tenderAgencyName  || "-"}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="招标公告发布时间：" prop='datetimerange' style="width:100%;">
                                <span>{{form.noticePubTimes  || "-"}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="项目合同签署时间：" prop='datetimerange1' style="width:100%;">
                                <span>{{form.contractSignTimes  || "-"}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="抽取数量组成方式：" prop='ruleType' style="width:100%;">
                                <el-radio-group v-model="form.ruleType" disabled>
                                    <el-radio :label="1">数量</el-radio>
                                    <el-radio :label="2">百分比</el-radio>
                                    <el-radio :label="3">复合方式</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="form.ruleType == 1 || form.ruleType == 2">
                            <el-form-item label="抽取数量：" prop='extractRule' style="width:100%;">
                                <span>从符合条件的总数中随机抽取</span> <span>{{form.extractRule + ' ' + (form.ruleType == 1?'个':' %')}}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="form.ruleType == 3">
                            <el-form-item label="项目抽取条件：" prop='extractRule' style="width:100%;">
                                <table class="role_table">
                                    <thead style="width: 100%;">
                                    <th width="50%">
                                        <span>{{formatterDataDictionary(extractNumberTypeList,form.ruleCompMethod)}}</span>
                                    </th>
                                    <th width="50%">
                                        <span>{{form.numOrPercentType == '1'?'数量':'比例'}}</span>
                                    </th>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(item,index) in ruleList" :key="index">
                                        <td>
                                            <p v-if="form.ruleCompMethod == '1'">
                                                <span>{{item.projectTypeName}}</span>
                                            </p>
                                            <p v-else-if="form.ruleCompMethod == '2'">
                                                介于 <span>{{item.currencyMin}}</span>万元 至 <span>{{item.currencyMax}}</span> 万元
                                            </p>
                                            <p v-else>
                                                <span>{{item.regionCodeName}}</span>
                                            </p>
                                        </td>
                                        <td>
                                            符合抽取条件总项目的
                                            <span>{{item.numOrPercent}}</span><span>{{form.numOrPercentType == '1'?'个':'%'}}</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>执法检查人员抽取规则</span>
                    </div>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="本次执法人员：" prop='extractPondPersonList' style="width:100%;">
                                <p style="margin: 0">共计 <span>{{extractPondPersonList.length}}</span>名</p>
                                <span style="margin: 0" v-for="(item,index) in extractPondPersonList" :key="index">{{item.personName + (item.personDesc?("（" + item.personDesc +  "）"):'')}}；</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="执法人员分组：" prop='groupNum' style="width:100%;">
                                共分为<span>{{form.groupNum}}</span>个小组
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>项目双随机匹配结果</span>
                    </div>
                    <div>
                        <div class="titleBox">
                            <h3 class="twoTitle">双随机抽取结果表</h3>
                            <div class="noticeBtn">
                                <el-button type="text" @click="resultNoticeFn('2')">通知执法检查人员</el-button>
                                <el-button type="text" @click="resultNoticeFn('1')">通知项目主体</el-button>
                            </div>
                            <div class="twoTitleNav">
                                <span>抽取人员： <span>{{form.extractorName}}</span> </span>
                                <span>抽取完成时间： <span>{{form.extractTime}}</span> </span>
                            </div>
                        </div>
                    </div>
                    <el-table :data="resultTableData" stripe
                              :header-cell-style="this.$globalGrayTableHeaderStyle" border>
                        <el-table-column fixed label="序号" type="index" width="50" align="center"
                                         :show-overflow-tooltip='true'></el-table-column>
                        <el-table-column label="项目名称" prop='bidSectionName' header-align="center" align="left"
                                         min-width='200'
                                         :show-overflow-tooltip='true'>
                        </el-table-column>
                        <el-table-column label="项目编号" prop='bidSectionCode' width='200' header-align="center" align="center"
                                         :show-overflow-tooltip='true'>
                        </el-table-column>
                        <el-table-column label="项目类型" prop='projectTypeName' header-align="center" align="center"
                                         width='100'
                                         :show-overflow-tooltip='true'>
                        </el-table-column>
                        <el-table-column label="合同金额（元）" prop='contractMoney' align="center"
                                         width="140"
                                         :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                <span>{{scope.row.contractMoney}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="招标公告发布时间" prop='tenderBulletinDate' align="center" width='150'
                                         :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                <span>{{formatDate(scope.row.tenderBulletinDate,'yyyy-MM-dd HH:mm:ss')}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="合同签署时间" prop='contractSignDate' header-align="center" align="center" width='150'
                                         :show-overflow-tooltip='true'>
                            <template slot-scope="scope">
                                <span>{{formatDate(scope.row.contractSignDate,'yyyy-MM-dd HH:mm:ss')}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="执法检查人员" prop='executorsIdsName' header-align="center" align="center"
                                         min-width='200'
                                         :show-overflow-tooltip='true'>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="230">
                            <template slot-scope="scope">
                                <el-button type="text" size="small"  @click="routerDetail(scope.row,'project')">查看项目信息</el-button>
                                <el-button type="text" size="small"  @click="routerDetail(scope.row,'result')">录入检查结果</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                </el-card>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    // import {tabsCloseCurrentHandle,removeTabHandle} from '@/utils/routeTab';
    export default {
        name: "extractResult",
        components: {

        },
        data(){
            return{
                id:"",
                loading:false,
                extractNumberTypeList:[],
                form:{
                    id:'',
                    historyid:'-1',
                    processinstanceid:"",
                    processinstancecreatedate:"",
                    businessType:"",
                    entityId:"",
                    flowId:'',
                    tenderProjectCode:'',
                    bidSectionCode:'',
                    projectCode:'',
                    superviseDeptCodeName:"",
                    rejectCode:'',
                    ruleType:1, // 抽取规则类型  1,2,3
                    extractRule:"",// 抽取规则
                    mathRule:1, // 小数位取整规则 1四舍五入 2向下取整 3向上取整
                    workName:"",
                    ruleCompMethod:'1',
                    ruleCompMethodName:"",
                    numOrPercentType:'1',
                    taskId:"",
                    extractCode:"",
                    extractTime:"",
                    extractNum:"",
                    extractorName:"",
                },
                ruleList:[],
                extractPondPersonList:[],
                resultTableData:[],
            }
        },
        filters:{

        },
        created(){
            this.getDic("extract_number_type")
        },
        computed: {
            ...mapState({
                stateData:state=>state.user
            })
        },
        activated() {
            // $route.query.id为首页通过 url跳转 带过来的参数
            this.form.id = this.$route.query && this.$route.query.id ;
            this.getDetailById();
        },
        methods:{

            routerDetail(command,type){
                if(type == 'project'){
                    let paramMap = {
                        tenderProjectCode:command.tenderProjectCode || '',
                        bidSectionCode:command.bidSectionCode || '',
                        projectCode:command.projectCode || '',
                        bidSectionName:command.bidSectionName || '',
                        applyCode:"",
                        idcard:"",
                    }
                    window.sessionStorage.setItem("witnessHisDetailParamMap",JSON.stringify(paramMap))
                    removeTabHandle('businessWitnessHis_detail')
                    this.$router.push({
                        name: "businessWitnessHis_detail",
                        params: { paramMap:paramMap },
                        query:{
                            businessType:command.businessType,
                            angleType:0,
                            purchaserMode:command.purchaserMode || '',

                        },
                    });
                }

                if(type == 'result'){
                    removeTabHandle('inspectionResult_detail')
                    this.$router.push({
                        name:'inspectionResult_detail',
                        query:{
                            id:command.checkResultBaseId || '',
                            type:1
                        }
                    })

                }

            },

            resultNoticeFn(type){
                this.$httpReq.get('/projectDoubleExtract/extracttask/sendMessage?extractTaskId='+this.form.id+'&sendType='+type).then(res=>{
                    if(res.data.code == '1'){
                        this.$message.success(res.data.msg)
                        return
                    }
                    this.$message.error(res.data.msg)
                })
            },

            getDic(type) { // 获取字典
                this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
                    if (res.data.code === '1') {
                        switch (type) {
                            case 'extract_number_type':this.extractNumberTypeList = res.data.data;break;
                            case '146':this.projectTypeList = res.data.data;break;
                        }
                    }
                })
            },
            //列表查看进来根据id查询详情
            getDetailById(){
                if(this.form.id){
                    // 查询任务基本信息
                    this.$httpReq.get('/projectDoubleExtract/extracttask/get?id='+this.form.id).then(res=>{
                        if(res.data.code == '1'){
                            let resData = res.data.data;
                            this.form.workName = resData.workName
                            this.form.extractCode = resData.extractCode
                            this.form.extractTypeName = resData.extractTypeName
                            this.form.supervisionIdsName = resData.supervisionIdsName
                            this.form.extractTime = resData.extractTime
                            this.form.extractorName = resData.extractorName
                            return
                        }
                        this.$message.error(res.data.msg)
                    })
                    // 项目/交易主体抽取规则
                    this.$httpReq.get('/projectDoubleExtract/extractfilter/getExtractFilter?extractTaskId='+this.form.id).then(res=>{
                        if(res.data.code == '1' && res.data.data ){
                            let resData = res.data.data;
                            this.form.projectName = resData.projectName
                            this.form.superviseDeptCodeName = resData.superviseDeptCodeName
                            this.form.tendererName = resData.tendererName
                            this.form.tenderAgencyName = resData.tenderAgencyName
                            this.form.ruleType = resData.ruleType;
                            if(resData.ruleType == 3){
                                let extractRule = JSON.parse(resData.extractRule);
                                this.form.ruleCompMethod = extractRule.ruleCompMethod;
                                this.form.numOrPercentType = extractRule.numOrPercentType;
                                this.ruleList = extractRule.ruleList;
                            }else{
                                this.form.extractRule = resData.extractRule
                            }
                            this.form.noticePubTimes = resData.noticePubTimes?resData.noticePubTimes.replace("&","至"):"";
                            this.form.contractSignTimes = resData.contractSignTimes?resData.contractSignTimes.replace("&","至"):"";

                        }
                    })
                    // 执法人员抽取规则
                    this.$httpReq.get('/projectDoubleExtract/extractexectorfilter/getPersonAndRule?extractTaskId='+this.form.id).then(res=>{
                        if(res.data.code == '1' && res.data.data){
                            this.extractPondPersonList = res.data.data.executorList || [];
                            this.form.groupNum =res.data.data.executorFilter.groupNum || 0;
                        }else{
                            this.extractPondPersonList = [];
                            this.form.groupNum = 0;
                        }
                    })

                    // 获取选择执法人员和分组数
                    this.$httpReq.get('/projectDoubleExtract/extracttask/extractResultList?taskId='+this.form.id).then(res=>{
                        if(res.data.code == '1' && res.data.data){
                            this.resultTableData = res.data.data
                        }else{
                            this.resultTableData = [];
                        }
                    })


                }else{
                    this.$router.push({
                        name:'home'
                    })
                }

            },


            // 返回
            back(routerName,params){
                tabsCloseCurrentHandle();
                this.$router.push({
                    name:routerName,
                    query:params||{}
                })

            },

        },
        deactivated(){
        },
    }
</script>

<style lang="scss" scoped>

    .titleBox{
        background: rgba(239, 243, 246, 0.5);
        padding: 18px 0 10px 0;
        position: relative;
        .twoTitle{
            width: 100%;
            font-size: 24px;
            line-height: 24px;
            font-family: FZZDHJW--GB1-0, FZZDHJW--GB1;
            font-weight: 600;
            margin: 0;
            padding: 0;
            text-align: center;
        }

        .noticeBtn{
            display: inline-block;
            position: absolute;
            left: 50%;
            margin-left:108px;
            top: 28px;
        }

        .twoTitleNav{
            display: flex;
            justify-content: space-between;
            padding: 0 12px;
            &>span{
                display: inline-block;
            }
        }
    }


    .role_table{
        width: 100%;
        padding: 0;
        margin: 0;
        border: 1px solid #ebeef5;
        border-spacing: 0;
        border-collapse: collapse;
        text-align: center;
        th {
            border: 1px solid #ebeef5;
            padding:6px 10px;
            margin: 0;
            height: 44px;
            border-spacing: 0;
            border-collapse: collapse;
            color: #909399;
        }
        td {
            padding:6px 10px;
            margin: 0;
            height: 44px;
            border-collapse: collapse;
            border-spacing:0;
            border:1px solid #ebeef5;
        }
    }
</style>